/**
 *  Redux cleanup
 *  Pathlabel needs to be reset to its
 *  initial value every time the layout re-renders (e.g. "every page").
 *  because it is a page-sensitive value
 */

import { useCallback } from 'react'

import { useHiddenFormParams } from '.'
import { hiddenFormParamEnums } from '../enums'

type CallbackFunction = () => void

const usePageCleanup = (): CallbackFunction => {
  // create a memoized cleanup funcion
  // i.e. will only be computed when dependencies change
  const { mergeHiddenFormParams } = useHiddenFormParams()

  const cleanup: () => void = useCallback(() => {
    mergeHiddenFormParams([
      {
        default: window.location.href,
        key: hiddenFormParamEnums.keys.PATH_LABEL,
      },
    ])
  }, [mergeHiddenFormParams])

  return cleanup
}

export default usePageCleanup
